import { render, staticRenderFns } from "./add_suspicious.vue?vue&type=template&id=5bb2a324&scoped=true"
import script from "./add_suspicious.vue?vue&type=script&lang=js"
export * from "./add_suspicious.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_85618a750ecf9a6cb90ae78d3f60d7c3/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bb2a324",
  null
  
)

export default component.exports